import ApiService from './ApiService'

// Store User scoped lists
export const apiListRoles = () => ApiService.get('/store_user/list/roles')
export const apiListBankAccounts = () => ApiService.get('/store_user/list/bank-accounts')
export const apiListBrands = () => ApiService.get('/store_user/list/brands')
export const apiListCategories = id => ApiService.get(`/store_user/list/categories/${id}`)
export const apiListExpenses = () => ApiService.get('/store_user/list/expenses')
export const apiListCustomers = () => ApiService.get('/store_user/list/customers')
export const apiListVendors = () => ApiService.get('/store_user/list/vendors')
export const apiListReferrals = () => ApiService.get('/store_user/list/referrals')
export const apiListProducts = () => ApiService.get('/store_user/list/products')
export const apiListPurchases = id => ApiService.get(`/store_user/list/purchases/${id}`)
export const apiListOrders = id => ApiService.get(`/store_user/list/orders/${id}`)

// Roles & Permissions
export const apiPermissions = () => ApiService.get('/store_user/permission-datas')
export const apiRolesList = data => ApiService.get('/store_user/roles', data)
export const apiRolesView = id => ApiService.get(`/store_user/roles/${id}`)
export const apiRolesForm = (id, data) => ApiService.post(`/store_user/roles${id ? `/${id}` : ''}`, data)
export const apiRolesStatus = id => ApiService.post(`/store_user/roles/${id}/status`)

// Store Users
export const apiStoreUsersList = data => ApiService.get('/store_user/store-users', data)
export const apiStoreUsersView = id => ApiService.get(`/store_user/store-users/${id}`)
export const apiStoreUsersForm = (id, data) => ApiService.post(`/store_user/store-users${id ? `/${id}` : ''}`, data)
export const apiStoreUsersStatus = id => ApiService.post(`/store_user/store-users/${id}/status`)
export const apiStoreUsersVerified = id => ApiService.post(`/store_user/store-users/${id}/verified`)

// Bank Accounts
export const apiBankAccountsList = data => ApiService.get('/store_user/bank-accounts', data)
export const apiBankAccountsView = id => ApiService.get(`/store_user/bank-accounts/${id}`)
export const apiBankAccountsForm = (id, data) => ApiService.post(`/store_user/bank-accounts${id ? `/${id}` : ''}`, data)
export const apiBankAccountsStatus = id => ApiService.post(`/store_user/bank-accounts/${id}/status`)

// Bank Transactions
export const apiBankTransactionsList = data => ApiService.get('/store_user/bank-transactions', data)
export const apiBankTransactionsForm = (id, data) => ApiService.post(`/store_user/bank-transactions${id ? `/${id}` : ''}`, data)
export const apiBankTransactionsExport = data => ApiService.get('/store_user/bank-transactions-export', data)

// Wallet Transactions
export const apiWalletTransactionsList = data => ApiService.get('/store_user/wallet-transactions', data)
export const apiWalletTransactionsForm = (id, data) =>
    ApiService.post(`/store_user/wallet-transactions${id ? `/${id}` : ''}`, data)
export const apiWalletTransactionsExport = data => ApiService.get('/store_user/wallet-transactions-export', data)

// Customers
export const apiCustomersList = data => ApiService.get('/store_user/customers', data)
export const apiCustomersView = id => ApiService.get(`/store_user/customers/${id}`)
export const apiCustomersForm = (id, data) => ApiService.post(`/store_user/customers${id ? `/${id}` : ''}`, data)
export const apiCustomersStatus = id => ApiService.post(`/store_user/customers/${id}/status`)
export const apiCustomersClear = id => ApiService.post(`/store_user/customers/${id}/clear`)

// Vendors
export const apiVendorsList = data => ApiService.get('/store_user/vendors', data)
export const apiVendorsView = id => ApiService.get(`/store_user/vendors/${id}`)
export const apiVendorsForm = (id, data) => ApiService.post(`/store_user/vendors${id ? `/${id}` : ''}`, data)
export const apiVendorsStatus = id => ApiService.post(`/store_user/vendors/${id}/status`)

// Products
export const apiProductsList = data => ApiService.get('/store_user/products', data)
export const apiProductsView = id => ApiService.get(`/store_user/products/${id}`)
export const apiProductsForm = (id, data) => ApiService.post(`/store_user/products${id ? `/${id}` : ''}`, data)
export const apiProductsExport = data => ApiService.get('/store_user/products-export', data)

// Purchases
export const apiPurchasesProducts = data => ApiService.get('/store_user/purchases/products', data)
export const apiPurchasesList = data => ApiService.get('/store_user/purchases', data)
export const apiPurchasesView = id => ApiService.get(`/store_user/purchases/${id}`)
export const apiPurchasesForm = (id, data) => ApiService.post(`/store_user/purchases${id ? `/${id}` : ''}`, data)
export const apiPurchasesStatus = (id, data) => ApiService.post(`/store_user/purchases/${id}/status`, data)
export const apiPurchasesInvoice = id => ApiService.get(`/store_user/purchases/${id}/invoice`, null, { responseType: 'blob' })
export const apiPurchasesReturn = (id, data) => ApiService.post(`/store_user/purchases/${id}/return`, data)

// Store Orders
export const apiStoreOrdersProducts = data => ApiService.get('/store_user/store-orders/products', data)
export const apiStoreOrdersList = data => ApiService.get('/store_user/store-orders', data)
export const apiStoreOrdersView = id => ApiService.get(`/store_user/store-orders/${id}`)
export const apiStoreOrdersForm = (id, data) => ApiService.post(`/store_user/store-orders${id ? `/${id}` : ''}`, data)
export const apiStoreOrdersStatus = (id, data) => ApiService.post(`/store_user/store-orders/${id}/status`, data)
export const apiStoreOrdersInvoice = id =>
    ApiService.get(`/store_user/store-orders/${id}/invoice`, null, { responseType: 'blob' })

// Orders
export const apiOrdersProducts = data => ApiService.get('/store_user/orders/products', data)
export const apiOrdersReturnProducts = data => ApiService.get('/store_user/orders/returns/products', data)
export const apiOrdersList = data => ApiService.get('/store_user/orders', data)
export const apiOrdersView = id => ApiService.get(`/store_user/orders/${id}`)
export const apiOrdersForm = (id, data) => ApiService.post(`/store_user/orders${id ? `/${id}` : ''}`, data)
export const apiOrdersStatus = (id, data) => ApiService.post(`/store_user/orders/${id}/status`, data)
export const apiOrdersInvoice = id => ApiService.get(`/store_user/orders/${id}/invoice`, null, { responseType: 'blob' })
export const apiOrdersReturn = (id, data) => ApiService.post(`/store_user/orders/${id}/return`, data)
export const apiOrdersExport = data => ApiService.get('/store_user/orders-export', data)
